export default {
  methods: {
    // похоже что эта функция не используется
    /**
     * Возвращает true 
     * если 
     *    сейчас не пересекает,
     *    и
     *    после будет пересечено
     * тогда
     *    вернет true
     * иначе
     *    вернет false
     * 
     * @returns {boolean}
     */
    _isGoesOutBottomEdge(){
      return true;
    },

    _isBottomNowOut(){
      return this._getCurrentBottomDifference() > 0;
    },
    _isBottomWillOut(delta){
      let result = false;
      if (
        (this._getBottomImage() + (delta * this._getScale()))
        // (this._getBottomImage() + (delta))
        >
        this._getBottomWrapper()
      ){
        result = true;
      }

      return result;
    },
    _isTopNowOut(){
      return this._getCurrentTopDifference() < 0;
    },
    _isTopWillOut(delta){
      let result = false;
      if (
        (this._getTopImage() + (delta * this._getScale()))
        // (this._getTopImage() + (delta))
        <
        this._getTopWrapper()
      ){
        result = true;
      }

      return result;
    },
    
    _isRightNowOut(){
      return this._getCurrentRightDifference() > 0;
    },
    _isRightWillOut(delta){
      let result = false;
      if (
        (this._getRightImage() + (delta * this._getScale()))
        >
        this._getRightWrapper()
      ){
        result = true;
      }

      return result;
    },
    _isLeftNowOut(){
      return this._getCurrentLeftDifference() < 0;
    },
    _isLeftWillOut(delta){
      let result = false;
      if (
        (this._getLeftImage() + (delta * this._getScale()))
        <
        this._getLeftWrapper()
      ){
        result = true;
      }

      return result;
    },
    
    
    /**
     * Возвращает
     * насколько верхняя грань изображения 
     * ниже чем
     * верхняя грань обертки
     * @returns {number}
     * @private
     */
    _getCurrentTopDifference(){
      return this._getTopImage() - this._getTopWrapper();
    },
    _getCurrentLeftDifference(){
      return this._getLeftImage() - this._getLeftWrapper();
    },
    /**
     * Возвращает
     * насколько нижняя грань изображения
     * ниже чем
     * нижняя грань обертки
     * @returns {number}
     * @private
     */
    _getCurrentBottomDifference(){
      return this._getBottomImage() - this._getBottomWrapper();
    },
    _getCurrentRightDifference(){
      return this._getRightImage() - this._getRightWrapper();
    },
    _getTopImage(){
      return this.$refs.nImg.getBoundingClientRect().top;
    },
    _getTopWrapper(){
      return this.$refs.nImgWrapper.getBoundingClientRect().top;
    },
    _getBottomImage(){
      return this.$refs.nImg.getBoundingClientRect().bottom;
    },
    _getBottomWrapper(){
      return this.$refs.nImgWrapper.getBoundingClientRect().bottom;
    },
    _getLeftImage(){
      return this.$refs.nImg.getBoundingClientRect().left;
    },
    _getLeftWrapper(){
      return this.$refs.nImgWrapper.getBoundingClientRect().left;
    },
    _getRightImage(){
      return this.$refs.nImg.getBoundingClientRect().right;
    },
    _getRightWrapper(){
      return this.$refs.nImgWrapper.getBoundingClientRect().right;
    },

    _getScaledDeltas(he){
      let scaleX = this.transformer.getScaleX();
      return {
        x: he.changedPointers[0].movementX / scaleX,
        y: he.changedPointers[0].movementY / scaleX
      }
    },

    _getScale(){
      return this.transformer.getScaleX()
    },
    
    /**
     * Если все грани изображения находятся внутри обертки
     * Это не сравнение ширины. Это реально помещается или нет.
     */
    _isImageFitsToWrapper() {
      // let cond1 = Math.ceil(this._getTopImage()) >= Math.floor(this._getTopWrapper())
      // let cond2 = Math.floor(this._getBottomImage()) <= Math.ceil(this._getBottomWrapper())
      // let cond3 = Math.round(this._getLeftImage()) >= Math.round(this._getLeftWrapper())
      // let cond4 = Math.round(this._getRightImage()) <= Math.round(this._getRightWrapper())
      
      // console.clear()
      // console.log(this._getBottomImage())
      // console.log(this._getBottomWrapper())
      // console.log(cond1)
      // console.log(cond2)
      // console.log(cond3)
      // console.log(cond4)
      // let result = cond1 && cond2 && cond3 && cond4;
      // console.log(result)
      
      let res = this._isImageFitsToWrapperHorizontally() && this._isImageFitsToWrapperVertically();
      return res;
      // return result;
    },
    _isImageFitsToWrapperHorizontally(){
      let cond3 = Math.round(this._getLeftImage()) >= Math.round(this._getLeftWrapper())
      let cond4 = Math.round(this._getRightImage()) <= Math.round(this._getRightWrapper())
      let result = cond3 && cond4;
      return result;
    },
    _isImageFitsToWrapperVertically(){
      let cond1 = Math.ceil(this._getTopImage()) >= Math.floor(this._getTopWrapper())
      let cond2 = Math.floor(this._getBottomImage()) <= Math.ceil(this._getBottomWrapper())
      let result = cond1 && cond2;
      return result;
    },

    // TODO: Вынести, блять,эти 4 проверяльщика в отдельный файл, 
    // TODO и там отрефакторить
    // TODO сделать для каждого if-а свою переменную с внятным именем, 
    // TODO значение которой получается на основе отдельной соответствующей функции.
    // TODO Для преобразователей в каждом ифе сделать тоже по функции с внятным названием.
    // TODO Если в теле ифа используется еще оно условие - создать для него тоже по переменной и по функции
    
    /**
     * Образцовый проверяльщик. На основе него сделаны остальные 4 для остальных направлений.
     * @param delta
     * @returns {*}
     * @private
     */
    _modifyDeltaForPanDown(delta){
      // return delta;
      let bottomNowOut = this._isBottomNowOut();
      let bottomWillOut  = this._isBottomWillOut(delta);
      let topNowOut = this._isTopNowOut();
      let topWillOut = this._isTopWillOut(delta);

      let isImageShiftedTop = this._isImageShiftedTop();

      // тут так устроено, что в теории должен сработать только 1 if
      // но если я облажался в предыдущих 4-х подсчетах, то могут сработать и несколько
      // по хорошему (оптимально) было-бы сделать через else if, но тогда будет неудобно тестировать.
      if (
        // была и осталась внутри
        bottomNowOut && bottomWillOut
        &&
        topNowOut && topWillOut
      ) {

      }

      else if (
        // была снаружи, но заходит внутрь сверху
        bottomNowOut && bottomWillOut
        &&
        topNowOut && !topWillOut
      ) {
        // докрутить чтобы состыковались верхние границы
        delta = -this._getCurrentTopDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }
      else if (
        bottomNowOut && bottomWillOut
        &&
        !topNowOut && !topWillOut
      ){
        return 0;
      }
      else if (
        !bottomNowOut && bottomWillOut
        &&
        !topNowOut && !topWillOut
      ){
        // находится внутри,хочет выйти снизу
        // delta = -this._getCurrentBottomDifference();
        // delta = delta / this._getScale(); // пушо это применится в трансформ
        if (!isImageShiftedTop) {
          delta = 0;
        } else {
          let currDistToCent = -(this.transformer.getTranslateY());
          if (delta > currDistToCent){
            delta = currDistToCent;
          }
        }
      }
      else if (
        // сейчас залезло наверх, но хочет вылезти всерху и залезть вниз
        !bottomNowOut && bottomWillOut
        &&
        topNowOut && !topWillOut
      ){
        delta = -this._getCurrentTopDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }

      else if (
        // была и осталась внутри
        !topNowOut && !topWillOut
        &&
        !bottomNowOut && !bottomWillOut
      ) {
        if (!isImageShiftedTop) {
          delta = 0;
        }
        else {
          let currDistToCent = -(this.transformer.getTranslateY());
          if (delta > currDistToCent){
            delta = currDistToCent;
          }
        }
      }
      
      else {
        // console.log('noVariant')
      }

      return delta;
    },
    _modifyDeltaForPanRight(delta){
      
      let rightNowOut = this._isRightNowOut();
      let rightWillOut  = this._isRightWillOut(delta);
      let leftNowOut = this._isLeftNowOut();
      let leftWillOut = this._isLeftWillOut(delta);

      let isImageShiftedLeft = this._isImageShiftedLeft();
      
      if (
        // была и осталась снаружи по X
        rightNowOut && rightWillOut
        &&
        leftNowOut && leftWillOut
      ) {

      }

      else if (
        // была снаружи, но заходит внутрь наружу слева
        rightNowOut && rightWillOut
        &&
        leftNowOut && !leftWillOut
      ) {
        // докрутить чтобы состыковались верхние границы
        delta = -this._getCurrentLeftDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }
      else if (
        rightNowOut && rightWillOut
        &&
        !leftNowOut && !leftWillOut
      ){
        return 0;
      }
      else if (
        // была внутри, но выходит наружу справа
        !rightNowOut && rightWillOut
        &&
        !leftNowOut && !leftWillOut
      ){
        if (!isImageShiftedLeft) {
          delta = 0;
        } else {
          let currDistToCent = -(this.transformer.getTranslateX());
          if (delta > currDistToCent){
            delta = currDistToCent;
          }
        }
      }
      else if (
        // сейчас залезло наверх, но хочет вылезти всерху и залезть вниз
        !rightNowOut && rightWillOut
        &&
        leftNowOut && !leftWillOut
      ){
        delta = -this._getCurrentLeftDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }
      else if (
        // была и осталась внутри
        !leftNowOut && !leftWillOut
        &&
        !rightNowOut && !rightWillOut
      ) {
        if (!isImageShiftedLeft) {
          delta = 0;
        }
        else {
          let currDistToCent = -(this.transformer.getTranslateX());
          if (delta > currDistToCent){
            delta = currDistToCent;
          }
        }
      }

      else {
        // console.log('noVariant')
      }

      return delta;
    },

    _modifyDeltaForPanUp(delta){

      let bottomNowOut = this._isBottomNowOut();
      let bottomWillOut  = this._isBottomWillOut(delta);
      let topNowOut = this._isTopNowOut();
      let topWillOut = this._isTopWillOut(delta);

      let isImageShiftedBottom = this._isImageShiftedBottom();
      
      if (
        // была и осталась снаружи
        topNowOut && topWillOut
        &&
        bottomNowOut && bottomWillOut
      ) {

      }

      else if (
        // была внутри, но выходит наружу снизу
        topNowOut && topWillOut
        &&
        bottomNowOut && !bottomWillOut
      ) {
        // докрутить чтобы состыковались верхние границы
        delta = -this._getCurrentBottomDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }
      else if (
        topNowOut && topWillOut
        &&
        !bottomNowOut && !bottomWillOut
      ){
        return 0;
      }
      else if (
        // находится внутри,хочет выйти сверху
        !bottomNowOut && !bottomWillOut
        &&
        !topNowOut && topWillOut
      ){
        if (!isImageShiftedBottom) {
          delta = 0;
        }
        else {
          let currDistToCent = this.transformer.getTranslateY();
          if (-(delta) > currDistToCent){
            delta = currDistToCent;
            delta = -delta;
          }
        }
      }
      else if (
        // сейчас залезло вниз, но хочет вылезти снизу и залезть наверх
        !topNowOut && topWillOut
        &&
        bottomNowOut && !bottomWillOut
      ){
        delta = -this._getCurrentBottomDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }
      else if (
        // была и осталась внутри
        !topNowOut && !topWillOut
        &&
        !bottomNowOut && !bottomWillOut
      ) {
        if (!isImageShiftedBottom) {
          delta = 0;
        }
        else {
          let currDistToCent = this.transformer.getTranslateY();
          if (-(delta) > currDistToCent){
            delta = currDistToCent;
            delta = -delta;
          }
        }
      }
      else {
        // console.log('noVariant')
      }

      return delta;
    },
    _modifyDeltaForPanLeft(delta){

      let rightNowOut = this._isRightNowOut();
      let rightWillOut  = this._isRightWillOut(delta);
      let leftNowOut = this._isLeftNowOut();
      let leftWillOut = this._isLeftWillOut(delta);

      let isImageShiftedRight = this._isImageShiftedRight();

      if (
        // была и осталась снаружи
        leftNowOut && leftWillOut
        &&
        rightNowOut && rightWillOut
      ) {

      }

      else if (
        leftNowOut && leftWillOut
        &&
        rightNowOut && !rightWillOut
      ) {
        delta = -this._getCurrentRightDifference();
        delta = delta / this._getScale();
      }
      else if (
        leftNowOut && leftWillOut
        &&
        !rightNowOut && !rightWillOut
      ){
        return 0;
      }
      else if (
        !leftNowOut && leftWillOut
        &&
        !rightNowOut && !rightWillOut
      ){
        if (!isImageShiftedRight) {
          delta = 0;
        }
        else {
          let currDistToCent = this.transformer.getTranslateX();
          if (-(delta) > currDistToCent){
            delta = currDistToCent;
            delta = -delta;
          }
        }
      }
      else if (
        !leftNowOut && leftWillOut
        &&
        rightNowOut && !rightWillOut
      ){
        delta = -this._getCurrentRightDifference();
        delta = delta / this._getScale(); // пушо это применится в трансформ
      }

      else if (
        // была и осталась внутри
        !leftNowOut && !leftWillOut
        &&
        !rightNowOut && !rightWillOut
      ) {
        if (!isImageShiftedRight) {
          delta = 0;
        }
        else {
          let currDistToCent = this.transformer.getTranslateX();
          if (-(delta) > currDistToCent){
            delta = currDistToCent;
            delta = -delta;
          }
        }
      }

      else {
        // console.log('noVariant')
      }

      return delta;
    },



    _isImageShiftedRight(){
      return this.transformer.getTranslateX() > 0;
    },
    _isImageShiftedLeft(){
      let result = this.transformer.getTranslateX() < 0;
      // console.log(result)
      return result;
    },
    _isImageShiftedTop(){
      return this.transformer.getTranslateY() < 0;
    },
    _isImageShiftedBottom(){
      return this.transformer.getTranslateY() > 0;
    },
    
  }
};


// WEBPACK FOOTER //
// ./src/components/slide-main-calculations.mixin.js